<template>
    <form class="lesson-form" ref="lessonForm" :style="formStyle">
        <div class="form-content">
            <h2 v-show="showTitle" v-html="TitleText"></h2>


            <div class="form-basic-info">
                <div  class="form-item flex-item">
                    <select class="grade" v-model="weakGrade" @change="handleGradeChange" ref="grade">
                        <option :value="item[0]" v-for="(item, index) in subjectGrade" :key="index" >{{ item[1] }}</option>
                    </select>
                    <div class="arrow grade-arrow"></div>
                    <select class="subject" v-model="weakSubject" ref="subject">
                        <option :value="item[1]" v-for="(item, index) in weakSubjectArr" :key="index">{{ item[1] }}</option>
                    </select>
                    <div class="arrow subject-arrow"></div>
                </div>

                <div class="form-item">
                    <input type="text" :placeholder="placeholderName" class="username" :class="{ alert: userNameAlert }" v-model="userName" @blur="onBlurChange" />
                </div>
            </div>

            <div class="form-item">
                <span class="area-code">+86</span>
                <input type="number" :placeholder="placeholderTel" :class="{ alert: mobileAlert }" class="tel" v-model="mobile" maxlength="11" @blur="onBlurChange" />
            </div>

            <div class="form-item vertify-code" v-if="vertifyCodeStatus" >
                <input type="text" :placeholder="vertifyCodePlaceholder" class="identifyingcode" v-model="identifyingCode" />
                <span class="get-identify-code" @click.stop="identifySubmitBtn">{{codeCountDown}}</span>
            </div>
        </div>

        <div class="form-protocol">
            <img src="https://web-data.zmlearn.com/image/ut7ZfqyGo5aSiWmLPWCdCr/%E7%BC%96%E7%BB%84%205.png" v-if="checkProtocol" @click="checkProtocol = !checkProtocol" class="checkoutImg" />
            <img v-else src="https://web-data.zmlearn.com/image/7cCwbkGdtrLweuC3eEEHSw/%E6%A4%AD%E5%9C%86%E5%BD%A2.png" @click="checkProtocol = !checkProtocol" class="checkoutImg" />
            <div class="form-protocol-text">
                <span @click="checkProtocol = !checkProtocol">同意我们的</span>
                <span @click.stop="showProtocol = true" class="high-light">《用户隐私条款》</span>
            </div>
        </div>

        <div :style="btnStyle" class="zm-btn" @click="handleSubmitBtn()">
            <span>{{ btnText }}</span>
        </div>


        <div>
            <div class="info">
                <p v-if="index_form_showmsg">{{ index_form_showmsg }}</p>
                <img style="margin-right:5px" src="https://web-data.zmlearn.com/image/vRuqLVCMvKdxPdhcoQBoCv/%E5%BD%A2%E7%8A%B6.png" />
                <span style="color:#575757">{{ alertMsg }}</span>
            </div>
        </div>

        <div :class="{ 'mask-box': true}" v-if="showMask">
            <div class="verification-box">
                <img src="../../../components/lesson-form/img/dialog-close.png" @click="hideMask()" class="closeIcon" />
                <div class="phone-text">
                    验证码已发送至{{ mobile | filterPhoneNumber }}
                </div>
                <div class="code-box">
                    <input type="number" v-model="codeNumber" class="codeNumber" />
                    <div class="send-code" @click.stop="identifySubmitBtn()">
                        {{ codeCountDown }}
                    </div>
                </div>
                <div class="verification-btn" @click="checkBtn()">
                    最后一步，立即领取
                </div>
                <div class="bottom-title">领取后课程规划师会与您电话沟通课程详情</div>
            </div>
        </div>

        <protocol :showProtocol.sync="showProtocol"></protocol>
        <fail-dialog ref="failDialog"></fail-dialog>
        <bind-form ref="bindForm" :mobile="mobile" @closeDialog="closeDialog" />
    </form>
</template>

<script>
    import api from "@/api";
    import {
        request,
        queryObj,
        isEmptyObject,
    } from "@/utils/util";
    import urlConfig from "@/config";
    import Protocol from "@/components/lesson-form/protocol";
    import failDialog from "@/components/fail-dialog/fail-dialog";
    import Toast from "@/base/toast/toast";
    import BindForm from "@/components/bindForm/index";
    import BindFormComponent from "@/components/bindForm/create";

    import {
        mapState
    } from "vuex";


    const FROM_DICT = [{
        "4": {
            trigger_site: "注册落地页领取弹窗中立即领取",
            event_id: "click_kid_act08_ljlq02",
            event_name: "点击|少儿|官网m端|预约试听",
            position: "注册落地页领取弹窗中立即领取",
        },
        "5": {
            trigger_site: "领取试听课成功",
            event_id: "enter_kid_act08_success",
            event_name: "进入|少儿|注册落地页|领取成功",
            position: "领取试听课成功",
        },
    }, ];

    export default {
        name: "lesson-form",
        components: {
            failDialog,
            Protocol,
            BindForm,
        },
        props: {
            index_form_showmsg: {
                type: String,
                default: "",
            },
            homepageWeekSubject: {
                type: String,
                default: "语文思维训练",
            },
            hasBottom: {
                type: Boolean,
                default: true,
            },
            placeholderName: {
                type: String,
                default: "请输入您孩子的姓名",
            },
            placeholderTel: {
                type: String,
                default: "请输入您的手机号码",
            },
            cssType: {
                type: String,
                default: "default",
            },
            showTitle: {
                type: Boolean,
                default: true,
            },
            TitleText: {
                type: String,
                default: '免费领取<span style="color: #F65051; font-size: 0.733rem; padding: 0 0.1rem;">200元</span>试听课',
            },
            btnStyle: {
                type: Object,
            },
            btnText: {
                type: String,
                default: "0元试听",
            },
            btnType: {
                type: String,
                default: "",
            },
            btnTextName: {
                type: String,
                default: "",
            },
            wxLinkUrl: {
                type: String,
                default: "",
            },
            formStyle: {
                type: Object,
                default () {
                    return {};
                },
            },
            alertMsg: {
                type: String,
                default: "为了您的权益，您的隐私将被严格保密",
            },
            type: {
                type: String,
                default: "",
            },
            tabIndex: {
                type: String,
                default: "",
            },
            comeFrom: {
                type: String,
                default: null,
            },
            vertifyCodePlaceholder: {
                type: String,
                default: "验证码",
            },
            showDialog: {
                type: Boolean,
                default: false,
            },
            trigger_site: {
                type: String,
                default: "1",
            },
        },
        data() {
            return {
                getCode: "获取验证码",
                codeCountDownNum: 60,
                codeCountSubmitNum: 3,
                vertifyCodeStatus: false,
                vertifyOnOff: true,
                submitOnOff: true,
                userName: "",
                weakGrade: "小三",
                weakSubject: "语文思维训练",
                gradeData: [],
                mobile: "",
                identifyingCode: "",
                channelProgram: "",
                userNameAlert: false,
                mobileAlert: false,
                success: false,
                typeName: this.$route.query.type,
                checkProtocol: true,
                showProtocol: false,
                isWX: false,
                open_id: "",
                showMask: false,
                codeNumber: "",
                changMobile: false,
                subjectGrade:  [
                    ["幼儿园中班", "幼儿园中班"],
                    ["幼儿园大班", "幼儿园大班"],
                    ["小一", "一年级"],
                    ["小二", "二年级"],
                    ["小三", "三年级"],
                ],
                weakSubjectArr: [
                    ["语文", "语文思维训练"],
                    ["奥数", "数理逻辑训练"],
                ]
        };
        },
        filters: {
            filterPhoneNumber(number) {
                if (number.length === 11) {
                    let pat = /(\d{3})\d*(\d{4})/;
                    return (number = number.replace(pat, "$1****$2"));
                }
            },
        },
        watch: {
            subjectData: function () {
                // 异步获取到subjectData中的数据的话就执行这里
                // 默认显示高一
                this.$refs.grade.value = "小三";
                this.$nextTick(() => {
                    this.handleGradeChange();
                    this.initWeakSubject();
                    this.autoCompleteForm();
                });
            },
            userName() {
                this.userNameAlert = false;
            },
            mobile() {
                this.mobileAlert = false;
                this.changMobile = true;
            },
        },
        mounted() {
            this.open_id = this.urlQueryObj.open_id;
            this.isWX = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) === "micromessenger";
            // subjectData中的数据已经获取到的话就执行这里
            if (this.subjectData.length) {
                console.log("===");
                // 默认显示幼儿园中班
                this.$refs.grade.value = "小三";
                this.handleGradeChange();
                this.initWeakSubject();
                this.autoCompleteForm();
            }
            this.changeStatusByPlatform();
        },
        computed: {
            ...mapState([
                "subjectToLabel",
                "urlQueryObj",
                "subjectData"
            ]),
            codeCountDown() {
                if (this.codeCountDownNum === 60 || this.codeCountDownNum <= 0) {
                    return this.getCode;
                } else {
                    return this.codeCountDownNum + "s";
                }
            },
            submitCountDown() {
                return this.submitOnOff;
            },
        },
        created() {
            // if (process.browser) {
            //     this.$store.dispatch("getSubjectData");
            // }
        },
        methods: {
            initWeakSubject() {
                const defaultSubject = this.homepageWeekSubject;
                var $this = this.$refs.grade;
                var tmpArr1 = [];
                var tmpArr2 = [];
                this.weakSubjectArr.map((item, index) => {
                    tmpArr1.push(item[0]);
                    tmpArr2.push(item[1]);
                });
                this.weakSubject = defaultSubject;
                if (
                    tmpArr1.includes(this.weakSubject) ||
                    tmpArr2.includes(this.weakSubject)
                ) {
                    if (this.subjectToLabel[this.weakSubject]) {
                        this.weakSubject = this.subjectToLabel[this.weakSubject];
                    }
                } else {
                    this.weakSubject = this.subjectData[$this.selectedIndex][0][1];
                }
            },
            // alert(this.props.successType);
            // 带URL参数自动填入表单
            autoCompleteForm() {
                const query = queryObj();
                if (!isEmptyObject(query)) {
                    for (let key in query) {
                        if (query["userName"]) {
                            this.userName = decodeURIComponent(query["userName"]);
                        }
                        if (query["grade"]) {
                            this.weakGrade = decodeURIComponent(query["grade"]);
                        }

                        this.$refs.grade.value = this.weakGrade;
                        if (query["weakSubject"]) {
                            this.weakSubject = decodeURIComponent(query["weakSubject"]);
                        }
                        if (query["mobile"])
                            this.mobile = decodeURIComponent(query["mobile"]);
                        if (query["grade"]) this.grade = decodeURIComponent(query["grade"]);
                        if (query["channelProgram"]) {
                            this.channelProgram = decodeURIComponent(query["channelProgram"]);
                        }
                    }

                    // 对应的年级，自动切换科目

                    var $this = this.$refs.grade;

                    if ($this.selectedIndex >= 0) {
                        switch ($this.selectedIndex) {
                            case 0:
                                this.weakSubject = this.subjectData[0][0][0];
                                $this.options[$this.selectedIndex].selected = true;
                                break;
                            default:
                                var tmpArr1 = [];
                                var tmpArr2 = [];
                                this.weakSubjectArr.map((item, index) => {
                                    tmpArr1.push(item[0]);
                                    tmpArr2.push(item[1]);
                                });
                                if (
                                    tmpArr1.includes(this.weakSubject) ||
                                    tmpArr2.includes(this.weakSubject)
                                ) {
                                    if (this.subjectToLabel[this.weakSubject]) {
                                        this.weakSubject = this.subjectToLabel[this.weakSubject];
                                    }
                                } else {
                                    this.weakSubject = this.subjectData[$this.selectedIndex][0][0];
                                }
                                break;
                        }
                    } else {
                        if (JSON.stringify(this.subjectGrade).indexOf(this.weakGrade) === -1) {
                            this.weakGrade = "幼儿园中班";
                        }
                        this.weakSubject = this.subjectData[0][0][0];
                    }
                }
            },
            onBlurChange() {
                document.activeElement.scrollIntoViewIfNeeded(false);
                if (this.showDialog) window.scroll(0, 0);
            },
            changeStatusByPlatform() {
                const urlParams = queryObj() || {};
                if (request("cooperatorStore") !== "") {
                    this.vertifyCodeStatus = true;
                }
                api
                    .getPlatformOnOffStatus(urlParams)
                    .then((res) => {
                        if (res.data.code === 0) {
                            this.vertifyCodeStatus = !(request("cooperatorStore") == "" && res.data.data == false);
                        } else {
                            // console.log(res.data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            doRegister(isNew) {
                let self = this;
                if (self.submitOnOff) {
                    const timer2 = setInterval(() => {
                        this.codeCountSubmitNum--;
                        if (this.codeCountSubmitNum <= 0) {
                            clearInterval(timer2);
                            this.codeCountSubmitNum = 3;
                            self.submitOnOff = true;
                        } else {
                            this.submitOnOff = false;
                        }
                        return this.submitOnOff;
                    }, 1000);
                    const parmas1 = {
                        name: self.userName,
                        grade: self.weakGrade,
                        weakSubject: self.weakSubject,
                        mobile: self.mobile,
                        checkCodeFlag: true,
                        identifyingCode: self.vertifyCodeStatus ? self.identifyingCode : "",
                        completed: "1",
                        channelProgram: self.channelProgram,
                        channel_code: self.$route.query.channel_code || "",
                        channel_keyword: self.$route.query.channel_keyword || "",
                    };
                    const parmas2 = {
                        name: self.userName,
                        grade: self.weakGrade,
                        weakSubject: self.weakSubject,
                        mobile: self.mobile,
                        completed: "0",
                        channelProgram: self.channelProgram,
                        channel_code: self.$route.query.channel_code || "",
                        channel_keyword: self.$route.query.channel_keyword || "",
                    };

                    var parmas3 = {
                        referMobile: self.$route.query.referMobile || "",
                        stuGrade: self.weakGrade || "",
                        stuMobile: self.mobile || "",
                        stuName: self.userName || "",
                        weakSubject: self.weakSubject || "",
                    };
                    if (this.vertifyCodeStatus) {
                        this.parmas = parmas1;
                    } else {
                        this.parmas = parmas2;
                    }
                    const urlParams = queryObj();


                    if (this.comeFrom) {
                        this.parmas["comeFrom"] = this.comeFrom;
                    }
                    var page_id = window.location.href;
                    ZMSDK.onEvent("点击0元试听", "少儿m站", {
                        bu: "2",
                        channel_id: self.$route.query.channel_code,
                        refer_page_id: page_id,
                        page_id: page_id,
                    });

                    const isFollow = self.urlQueryObj.isFollow; // 在微信里打开，用户是否绑定
                    const open_id = self.urlQueryObj.open_id; // open_id
                    const isBind = self.urlQueryObj.isBind; // 是否关注
                    if (self.$route.query.referMobile) {
                        api.appointmentForMpReferral(parmas3).then((res) => {
                            if (res.data.code === 0) {
                                try {
                                    this.submitSuccessMD(); // 表单预约报名成功埋点
                                    // java接口改造 少儿各渠道广告回传接口调用下线
                                    // this.doAdvertCb(isNew)
                                    // this.handelBaiduApi() // 对接百度api
                                    // this.ucTrackCb(isNew); // uc信息api
                                } catch (error) {
                                    console.log(error);
                                }
                                if (res.data.data.data) {
                                    if (!this.vertifyCodeStatus) {
                                        // 页面无验证码
                                        // 判断是否标记
                                        this.judgeHasTag();
                                    } else {
                                        // 页面有验证码
                                        this.judgeJumpPage();
                                    }
                                } else {
                                    res.data.msg ?
                                        Toast(res.data.data.msg || "预约失败") :
                                        this.$refs.failDialog.postFormFail();
                                }
                            } else {
                                res.data.msg ?
                                    Toast(res.data.data.msg || "预约失败") :
                                    this.$refs.failDialog.postFormFail();
                            }
                        });
                    } else {
                        const weakGradeList = [
                            "幼儿园小班",
                            "幼儿园中班",
                            "幼儿园大班",
                            "小一",
                            "小二",
                            "小三",
                        ];
                        if (
                            self.$route.query.useridv2 &&
                            weakGradeList.includes(self.weakGrade)
                        ) {
                            api
                                .getSelectionClassTag({
                                    stuId: self.$route.query.useridv2 || ""
                                })
                                .catch((e) => console.log(e));
                        }
                        api
                            .postLessonFormNew(this.parmas)
                            .then((res) => {
                                if (res.data.code == 0) {
                                    this.submitSuccessMD(); // 表单预约报名成功埋点

                                    // java接口改造 少儿各渠道广告回传接口调用下线
                                    // this.doAdvertCb(isNew)
                                    // this.handelBaiduApi() // 对接百度api
                                    // this.ucTrackCb(isNew); // uc信息api
                                    if (!this.vertifyCodeStatus) {
                                        // 页面无验证码
                                        // 判断是否标记
                                        this.judgeHasTag();
                                    } else {
                                        // 页面有验证码
                                        this.judgeJumpPage();
                                    }
                                } else {
                                    res.data.message ?
                                        Toast(res.data.message) :
                                        this.$refs.failDialog.postFormFail();
                                }
                            })
                            .catch((err) => {
                                this.$refs.failDialog.postFormFail();
                            });
                    }
                    this.submitOnOff = false;
                }
            },
            vertifyCode(number) {
                if (number) {
                    let reg = new RegExp(/^\d{4}|\d{6}$/);
                    if (reg.test(number)) {
                        return true;
                    } else {
                        Toast("请输入正确的验证码");
                        return false;
                    }
                } else {
                    Toast("请输入验证码");
                    return false;
                }
            },
            checkBtn() {
                ZM_JSSDK &&
                ZM_JSSDK.sendEvent({
                    eventId: FROM_DICT[0][5].event_id,
                    eventParam: {
                        name: FROM_DICT[0][5].event_name,
                        code_site: FROM_DICT[0][5].trigger_site,
                    },
                });

                if (!this.vertifyCode(this.codeNumber)) return;
                // 校验验证码
                const validateParams = {
                    mobile: this.mobile,
                    verifycode: this.codeNumber,
                    verified: 1,
                };
                api
                    .validateNew(validateParams)
                    .then((res) => {
                        if (res.data.code * 1 === 0) {
                            // 验证码无误跳转页面
                            this.judgeJumpPage();
                        } else {
                            Toast(res.data.message);
                        }
                    })
                    .catch((err) => {
                        Toast(err);
                    });
            },
            hideMask() {
                this.showMask = false;
            },
            judgeJumpPage() {
                let self = this;
                const isFollow = self.urlQueryObj.isFollow; // 在微信里打开，用户是否绑定
                const open_id = self.urlQueryObj.open_id; // open_id
                const isBind = self.urlQueryObj.isBind; // 是否关注
                if (self.isWX && isFollow * 1 === 1) {
                    if (self.isWX && isFollow * 1 && isBind * 1 === 0) {
                        // 在微信端打开，已经关注 ，有open_id 已经绑定
                        // this.$refs.bindForm.show();
                        const _ = this;
                        BindFormComponent({
                            mobile: _.mobile,
                            open_id: open_id,
                            closeDialog: (success) => {
                                _.closeDialog(success);
                            },
                        });
                    } else {
                        // 新的报名成功页面
                        this.closeDialog(true);
                    }
                } else {
                    if (!this.goKid()) {
                        this.getFlatfrom(this.mobile, 1);
                    }
                }
            },
            identifySubmitBtn() {
                if (!/^\d+$/.test(this.mobile)) {
                    return Toast("请输入手机号");
                }
                if (!/^\d{11}$/.test(this.mobile)) {
                    return Toast("请填写正确手机号");
                }
                if (this.vertifyOnOff) {
                    this.vertifyOnOff = false;
                    api
                        .sendVerifierNew({ mobile: this.mobile })
                        .then((res) => {
                            if (res.data.code * 1 === 0) {
                                this.changMobile = false;
                                Toast("验证码发送成功");
                                const timer = setInterval(() => {
                                    this.codeCountDownNum--;
                                    if (this.codeCountDownNum <= 0 || this.changMobile) {
                                        clearInterval(timer);
                                        this.vertifyOnOff = true;
                                        this.codeCountDownNum = 60;
                                        this.codeNumber = "";
                                    }
                                }, 1000);
                            } else {
                                this.vertifyOnOff = true;
                                Toast(res.data.message || "验证码发送失败，请稍后再试");
                            }
                        })
                        .catch((err) => {
                            this.vertifyOnOff = true;
                            Toast(err);
                        })
                }
            },
            judgeHasTag() {
                if (!/^\d+$/.test(this.mobile)) {
                    return Toast("请输入手机号");
                }
                api
                    .hasTag({ mobile: this.mobile })
                    .then((res) => {
                        if (res.data.code * 1 === 0) {
                            if (res.data.data) {
                                // true则为标记过直接调转页面
                                this.judgeJumpPage();
                            } else {
                                // false则为未标记过显示验证码弹窗
                                this.showMask = true;
                                this.identifySubmitBtn(); // 显示验证码弹窗并自动发送验证码
                            }
                        } else {
                            Toast(res.data.msg[0]);
                        }
                    })
                    .catch((err) => {
                        Toast(err);
                    });
            },
            // 报名成功埋点
            submitSuccessMD() {
                ZM_JSSDK &&
                ZM_JSSDK.sendEvent({
                    eventId: FROM_DICT[0][5].event_id,
                    eventParam: {
                        name: FROM_DICT[0][5].event_name,
                        phone_num: this.mobile
                    },
                });
            },
            closeDialog(isBindSuccess) {
                if (isBindSuccess) {
                    this.$store.dispatch("bindSuccess");
                }
                this.getFlatfrom(self.mobile, 4);
            },
            async getFlatfrom(mobile, type) {
                let goPath = "";
                let params = {
                    mobile: this.mobile,
                    mark_id: this.$route.query.mark_id ? this.$route.query.mark_id : "",
                    origin_url: this.$route.query.origin_url ?
                        this.$route.query.origin_url : "",
                    weibo_path: this.$route.path,
                    path: "double11",
                    flatfrom: "少儿M站双11活动"
                };
                switch (type) {
                    case 1:
                        goPath = "appointment-success5";
                        break;
                    case 2:
                        goPath = "appointment-success-kid";
                        break;
                    case 4:
                        goPath = "appointment-success-wxbind";
                        break;
                }

                if (goPath === "appointment-success5") {
                    const mobile = this.mobile || "";
                    const flatfrom = this.$route.name || "";
                    const otherSiteFrom = "m-kid";
                    const grade = this.weakGrade || "";
                    const channel_code = this.$route.query.channel_code  || '';
                    const channel_keyword = this.$route.query.channel_keyword || '';
                    window.location.href = `${urlConfig.mSuccessPageURL}?mobile=${mobile}&grade=${grade}&otherSiteFrom=${otherSiteFrom}&flatfrom=${flatfrom}&channel_code=${channel_code}&channel_keyword=${channel_keyword}`;
                } else {
                    this.$router.push({
                        name: goPath,
                        params: params,
                        query: this.$route.query,
                    });
                }
            },
            goKid() {
                let kidWeakGrade = [
                    "幼儿园中班",
                    "小一",
                    "小二",
                    "小三",
                ];
                let kidWeakSubject = [
                    "数理逻辑训练",
                    "语文思维训练",
                ];
                if (
                    kidWeakGrade.includes(this.weakGrade) &&
                    kidWeakSubject.includes(this.weakSubject)
                ) {
                    this.getFlatfrom(this.mobile, 2);
                    return true;
                } else {
                    return false;
                }
            },
            validateForm() {
                return new Promise((resolve, reject) => {
                        if (!/^([a-zA-Z]|[\u4e00-\u9fa5]){1,}$/.test(this.userName)) {
                            this.userNameAlert = true;
                            reject("请填写正确的孩子姓名");
                        } else if (this.userName.length >= 7) {
                            this.userNameAlert = true;
                            reject("请填写正确的孩子姓名");
                        } else if (this.mobile.length == 0) {
                            this.mobileAlert = true;
                            reject("请输入手机号");
                        } else if (!/^\d{11}$/.test(this.mobile)) {
                            this.mobileAlert = true;
                            reject("请填写正确手机号");
                        } else if (
                            this.vertifyCodeStatus &&
                            !/^\d+$/.test(this.identifyingCode)
                        ) {
                            reject("请输入正确的验证码");
                        } else if (!this.checkProtocol) {
                            reject("请同意用户隐私协议");
                        } else {
                            resolve("success");
                        }
                });
            },
            handleGradeChange() {
                var $this = this.$refs.grade;
                switch ($this.selectedIndex) {
                    case 12:
                        this.weakSubject = this.subjectData[12][0][0];
                        $this.options[$this.selectedIndex].selected = true;
                        break;
                    default:
                        this.weakSubject = this.subjectData[$this.selectedIndex][0][1];
                        break;
                }
            },


            // 如果是新用户报名成功则回传微信完成转化跟踪
            handleSubmitBtn() {
                if ( ZM_JSSDK) {
                    let eventData = {
                        eventId: FROM_DICT[0][4].event_id,
                        eventParam: {
                            name: FROM_DICT[0][4].event_name,
                            grade: this.weakGrade,
                            subject: this.weakSubject,
                            trigger_site: FROM_DICT[0][4].trigger_site,
                            position: "弹窗"
                        },
                    };
                    ZM_JSSDK.sendEvent(eventData);
                }

                this.validateForm()
                    .then(() => {
                        this.checkAdvertNeed().then(this.doRegister);
                    })
                    .catch((err) => {
                        Toast(err);
                    });
            },

            checkAdvertNeed() {
                let {
                    gdt_vid,
                    qz_gdt,
                    clickid,
                    uctrackid
                } = this.$route.query;
                return new Promise((resolve, reject) => {
                    if (qz_gdt || gdt_vid || clickid || uctrackid) {
                        api
                            .checkIsNewUser({
                                mobile: this.mobile
                            })
                            .then((res) => {
                                if (res.data && res.data.code == 0) {
                                    resolve(res.data.data.isNewUser);
                                } else {
                                    resolve(false);
                                }
                            })
                            .catch(() => {
                                resolve(false);
                            });
                    } else {
                        resolve(false);
                    }
                });
            },

            // java接口改造 少儿各渠道广告回传接口调用下线
            doAdvertCb(isNew) {
                // 不区分新用户
                if (!isNew) {
                    return;
                }
                const {
                    clickid
                } = this.$route.query;
                const url = location.href;
                if (clickid) {
                    api.toutiaoAdvertCallback({
                        accountType: "tt_kid",
                        callbackType: 3,
                        clickId: clickid,
                        sourceUrl: encodeURIComponent(url),
                        userMobile: this.mobile,
                    });
                }
                let accountType = "KID_QQ_AD";

                let {
                    gdt_vid,
                    qz_gdt
                } = this.$route.query;
                if (gdt_vid) {
                    api.wechatAdvertCallback({
                        clickId: gdt_vid,
                        referUrl: window.location.href,
                        userMobile: this.mobile,
                        accountType: "zmkid0",
                    });
                }
                if (qz_gdt) {
                    api.qqAdvertCallback({
                        clickId: qz_gdt,
                        referUrl: window.location.href,
                        userMobile: this.mobile,
                        accountType: accountType,
                    });
                }
            },

        },
    };
</script>

<style lang="scss">
    // @import './../../styles/mixin.scss';
    @import "../../../components/lesson-form/css/lessonForm1.scss";

    .mask-box {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 999;

        .verification-box {
            width: px2rem(624);
            height: px2rem(504);
            border-radius: px2rem(20);
            position: relative;
            transform: translate(-50%, -50%);
            background: #fff;
            left: 50%;
            top: 50%;
            display: flex;
            flex-direction: column;
            padding-top: px2rem(80);
            box-sizing: border-box;
            align-items: center;

            .closeIcon {
                width: px2rem(24);
                height: px2rem(24);
                position: absolute;
                top: px2rem(24);
                right: px2rem(24);
            }

            .phone-text {
                width: 100%;
                text-align: center;
                height: px2rem(50);
                font-size: px2rem(36);
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
                line-height: px2rem(50);
                margin-bottom: px2rem(60);
            }

            .code-box {
                display: flex;
                align-items: center;
                width: px2rem(506);
                justify-content: space-around;
                margin-bottom: px2rem(60);

                input.codeNumber {
                    width: px2rem(318);
                    box-sizing: border-box;
                    height: px2rem(76);
                    background: rgba(246, 246, 246, 1);
                    border-radius: px2rem(8);
                    margin-right: px2rem(20);
                    font-size: px2rem(28);
                    font-weight: 600;
                    border: none;
                    padding: 0 px2rem(20);
                }

                .send-code {
                    text-align: center;
                    width: px2rem(186);
                    height: px2rem(68);
                    background: rgba(239, 76, 79, 1);
                    border-radius: px2rem(8);
                    font-size: px2rem(28);
                    font-weight: 600;
                    color: #fff;
                    line-height: px2rem(68);
                    font-family: PingFangSC-Semibold;
                }
            }

            .verification-btn {
                text-align: center;
                width: px2rem(444);
                height: px2rem(76);
                background: rgba(239, 76, 79, 1);
                border-radius: px2rem(42);
                font-size: px2rem(32);
                font-weight: 400;
                color: #fff;
                line-height: px2rem(76);
                font-family: PingFangSC-Regular;
                margin-bottom: px2rem(20);
            }

            .bottom-title {
                text-align: center;
                width: px2rem(456);
                height: px2rem(34);
                line-height: px2rem(34);
                font-family: PingFangSC-Regular;
                color: #666;
                font-size: px2rem(24);
            }
        }

        &.model-size {
            width: 100vw;
            height: 100vh;

            .verification-box {
                position: absolute;
                left: 48%;
                top: 20%;
                transform: translate(-50%, -50%);
            }
        }
    }

    .area-code {
        display: none;
    }
</style>
